import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import Table from '../../components/table/table.jsx';
import Loader from '../../components/loader/loader.jsx';
import * as FileSaver from 'file-saver';
import orderHistoryService from '../../services/orderHistoryService.js';
import { OrderHistoryColumns, OrderHistoryColumnsMobile } from '../../constants/table/order_histroy_columns.js';
import { useLocalization } from '../../hooks/useLocalization.js';

const OrderHistoryList = (props) => {
    const orderHistory = useSelector((store) => store.orderHistory.orderHistory);
    const filter = useSelector((store) => store.orderHistory.filter);
    const [loading, setLoading] = useState(false);
    const { t } = useLocalization();

    useEffect(() => {
        getData();
    }, []);

    const getData = async (filterToSelect) => {
        filterToSelect = filterToSelect ? filterToSelect : filter;
        try {
            setLoading(true);
            await orderHistoryService.getOrderHistory(filterToSelect);
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }

    const getReport = () => {
        orderHistoryService.getReport(filter).then(data => {
            if (data) {
                FileSaver.saveAs(data, 'order_history.xlsx');
            }
        });
    }

    const modelFilter = {
        orderNumber: {
            name: "orderNumber",
            type: "string",
            header: t('OrderHistory.OrderNumber'),
            value: filter.modelFilter.orderNumber
        }
    };

    return (
        <div>
            <MediaQuery minDeviceWidth={1224}>
                <Table settings={{
                    columns: OrderHistoryColumns,
                    items: orderHistory,
                    itemsFilter: Object.assign({}, filter, { filterProps: modelFilter }),
                    isEditable: false,
                    getItemsFunction: getData,
                    getReportFunction: getReport
                }} />
                {loading && <Loader />}
            </MediaQuery>
            <MediaQuery maxDeviceWidth={1224}>
                <Table settings={{
                    columns: OrderHistoryColumnsMobile,
                    items: orderHistory,
                    itemsFilter: Object.assign({}, filter, { filterProps: modelFilter }),
                    isEditable: false,
                    getItemsFunction: getData,
                    getReportFunction: getReport
                }} />
                {loading && <Loader />}
            </MediaQuery>
        </div>
    );

}


export default OrderHistoryList;